import {Component, OnDestroy, OnInit} from '@angular/core';
import {DataStorageService} from '../../shared/services/data-storage.service';
import {FormArray, FormControl, FormGroup} from '@angular/forms';
import {RouteService} from '../../shared/services/route.service';
import {Stop} from '../../shared/models/stop.model';
import {RouteGroup} from '../../shared/models/routeGroup.model';
import {SearchService} from '../../shared/services/search.service';
import {NgbDateParserFormatter} from '@ng-bootstrap/ng-bootstrap';
import {ToolsService} from '../../shared/services/tools.service';
import {UserService} from '../../shared/services/user.service';
import {User, UserLogin} from 'src/app/shared/models/user.model';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {IntlTellInputService} from '../../shared/services/intl-tell-input.service';
import {AuthenticationService} from '../../authentication/authentication.service';

const now = new Date();

@Component({
    selector: 'form-search-bulk',
    templateUrl: 'form-search-bulk.html',
    styleUrls: ['../../../assets/scss/plugins/_datepicker.scss']
})

export class FormSearchBulkComponent implements OnInit, OnDestroy {

    public navigation: any;

    selectConfig: any = {
        labelField: 'label',
        valueField: 'value',
        searchField: ['label']
    };

    multiSelectConfig: any = {
        labelField: 'label',
        valueField: 'value',
        searchField: ['label'],
        maxItems: 6
    };

    groupByConfig: any = {
        maxItems: 2,
        optgroupField: 'class',
        labelField: 'name',
        searchField: ['name'],
        render: {
            optgroup_header: function (data, escape) {
                return '<div class="optgroup-header">' +
                    escape(data.label) +
                    ' <span class="scientific">' +
                    escape(data.label_scientific) +
                    '</span></div>';
            }
        },
        optgroups: [
            {value: 'round', label: 'Round Chart', label_scientific: ''},
            {value: 'line', label: 'Line Chart', label_scientific: ''}
        ]
    };

    groupByOptions: any = [
        {class: 'round', value: 'route_group_id', name: 'Route Group'},
        {class: 'round', value: 'agency', name: 'Agency'},
        {class: 'round', value: 'route_id', name: 'Route'},
        {class: 'round', value: 'pick_stop_id', name: 'Pick Stop Location'},
        {class: 'round', value: 'drop_stop_id', name: 'Drop Stop Location'},
        {class: 'line', value: 'day', name: 'Day'},
        {class: 'line', value: 'month', name: 'Month'},
        {class: 'line', value: 'year', name: 'Year'}
    ];

    optGroupOptions: any;
    users: User[];

    model = {year: now.getFullYear(), month: now.getMonth() + 1, day: now.getDate()};

    date: { year: number, month: number };
    displayMonths = 2;

    searchListForm: FormGroup;
    searchChartForm: FormGroup;

    stops: Stop[];
    stopOptions: any = [];

    is_line: boolean;

    statusOptions: any = [
        {'label': 'confirmed', 'value': 'confirmed', 'code': 'confirmed'},
        {'label': 'pending', 'value': 'pending', 'code': 'pending'},
        {'label': 'canceled', 'value': 'canceled', 'code': 'canceled'}
    ];

    user: UserLogin;

    routeGroups: RouteGroup[];
    routeGroupOptions: any = [];

    private unsubscribe$: Subject<void> = new Subject<void>();

    constructor(private dataStorageService: DataStorageService,
                private routeService: RouteService,
                private searchService: SearchService,
                private ngDateParserFormatter: NgbDateParserFormatter,
                private userService: UserService,
                private intlTellInputService: IntlTellInputService,
                private authenticationService: AuthenticationService,
                private toolsService: ToolsService) {
        this.optGroupOptions = [];
    }


    ngOnInit() {

        // agency는 multiple options 선택되도록.

        this.stops = this.routeService.getStop();
        this.initStopOptions();

        this.routeService.stopsChanged
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(
                (stops: Stop[]) => {
                    this.stops = stops;
                    this.initStopOptions();
                }
            );

        this.routeGroups = this.routeService.getRouteGroup();

        this.routeService.routeGroupsChanged
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(
                (routeGroups: RouteGroup[]) => {
                    this.routeGroups = routeGroups;
                    this.initForm();
                    this.initRouteGroupOptions();
                }
            );

        this.userService.usersChanged
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(
                (users) => {
                    if (users) {
                        this.users = users;
                        this.initUserGroupOptions();
                    }
                }
            );

        if (this.userService.getUser()) {
            this.users = this.userService.getUser();
            this.initUserGroupOptions();
        }

        if (this.routeGroups.length !== 0) {
            this.initForm();
            this.initRouteGroupOptions();
        }

        this.intlTellInputService.tellChanged
            .pipe(takeUntil(this.unsubscribe$)).subscribe(
            (value) => {
                console.log(value);
                this.searchListForm.get('phone').setValue(value);
            }
        );

        this.intlTellInputService.isTellError
            .pipe(takeUntil(this.unsubscribe$)).subscribe(
            (value) => {
                // put any value when error because not null
                this.searchListForm.get('phone').setValue('');
                this.searchListForm.get('phone').markAsTouched();
                this.searchListForm.get('phone').markAsDirty();
                alert('Please enter valid phone');
            }
        );

        this.authenticationService.user.pipe(takeUntil(this.unsubscribe$)).subscribe(user => {
            console.log(user);
            this.user = user;
        });
    }

    initForm() {

        // search List Form

        const stopRouteGroups = new FormArray([]);

        for (const routeGroup of this.routeGroups) {
            const title = routeGroup.title;
            stopRouteGroups.push(
                new FormGroup({
                    'stop': new FormControl(),
                    'route_group_id': new FormControl(routeGroup.id),
                    'route_group_title': new FormControl(title.substr(title.length - 2))
                })
            );
        }

        this.searchListForm = new FormGroup({
            'ticket_no': new FormControl(),
            'pnr': new FormControl(),
            'last_name': new FormControl(),
            'first_name': new FormControl(),
            'email': new FormControl(),
            'phone': new FormControl(),
            'reservation_no': new FormControl(),
            'user_id': new FormControl(),
            'ip_address': new FormControl(),
            'created_from': new FormControl(),
            'created_to': new FormControl(),
            'departure_from': new FormControl(),
            'departure_to': new FormControl(),
            // 'return_from': new FormControl(),
            // 'return_to': new FormControl(),
            'stops': stopRouteGroups
        });


        // Search Chart Form

        const filters = new FormGroup({
            'status': new FormControl(),
            'agency': new FormControl(),
            'route_group_id': new FormControl(),
            'stop': new FormControl()
        });

        const ranges = new FormGroup({
            'created_from': new FormControl(),
            'created_to': new FormControl(),
            'on_board_from': new FormControl(),
            'on_board_to': new FormControl()
        });

        this.searchChartForm = new FormGroup({
            'filters': filters,
            'group_by': new FormControl(),
            'group_by_extra': new FormControl(),
            'ranges': ranges
        });

        this.onChanges();
    }

    initUserGroupOptions() {
        this.users.sort((a, b) => (a.user_name.toUpperCase() < b.user_name.toUpperCase() ? -1 : 1));
        for (const user of this.users) {
            this.optGroupOptions.push({'label': user.user_name, 'value': user.id, 'code': user.user_name});
        }
    }

    initStopOptions() {
        for (const stop of this.stops) {
            this.stopOptions.push({'label': stop.title, 'value': stop.id, 'code': stop.title});
        }
    }

    initRouteGroupOptions() {
        for (const routeGroup of this.routeGroups) {
            this.routeGroupOptions.push({'label': routeGroup.title, 'value': routeGroup.id, 'code': routeGroup.title});
        }
    }

    onChanges() {
        this.searchChartForm.get('group_by').valueChanges
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(
                (value) => {
                    this.toggleGroupByExtraForm(value);
                }
            );
    }

    toggleGroupByExtraForm(value: string) {
        if (value.indexOf('day') > -1 || value.indexOf('month') > -1 || value.indexOf('year') > -1) {
            this.is_line = true;
            this.searchChartForm.addControl('group_by_extra', new FormControl());
        } else {
            this.is_line = false;
            this.searchChartForm.removeControl('group_by_extra');
        }
    }

    onSubmitList() {

        const value = this.searchListForm.value;
        // console.log(value);
        const filter = {};

        if (value.ticket_no) {
            let ticket_no_raw = value.ticket_no;
            ticket_no_raw = ticket_no_raw.replace(/\D/g, '');
            const ticket_no_arr = [];
            const count = Math.round(ticket_no_raw.length / 10);
            for (let i = 0; i < count; i++) {
                ticket_no_arr.push(ticket_no_raw.slice((i * 10), (i * 10) + 10));
            }
            filter['ticket_no'] = ticket_no_arr;
        }
        if (value.pnr) {
            filter['pnr'] = value.pnr;
        }
        if (value.last_name) {
            filter['last_name'] = value.last_name;
        }
        if (value.first_name) {
            filter['first_name'] = value.first_name;
        }
        if (value.email) {
            filter['email'] = value.email;
        }
        if (value.phone) {
            filter['phone'] = value.phone;
        }
        if (value.reservation_no) {
            filter['reservation_no'] = value.reservation_no;
        }
        if (this.user.level < 2) {
            if (value.user_id) { filter['user_id'] = value.user_id; }   // 원하는 여행사 선택 가능
        } else {
            filter['user_id'] = this.user.id;                          // 본인 것만 강제
        }
        if (value.ip_address) {
            filter['ip_address'] = value.ip_address.trim();
        }
        if (value.created_from) {
            filter['created_from'] = this.ngDateParserFormatter.format(value.created_from);
        }
        if (value.created_to) {
            filter['created_to'] = this.ngDateParserFormatter.format(value.created_to);
        }
        if (value.departure_from) {
            filter['departure_from'] = this.ngDateParserFormatter.format(value.departure_from);
        }
        if (value.departure_to) {
            filter['departure_to'] = this.ngDateParserFormatter.format(value.departure_to);
        }
        // if (value.return_from) {
        //     filter['return_from'] = this.ngDateParserFormatter.format(value.return_from);
        // }
        // if (value.return_to) {
        //     filter['return_to'] = this.ngDateParserFormatter.format(value.return_to);
        // }
        filter['stops'] = [];
        for (const stop of value.stops) {
            if (stop.stop) {
                filter['stops'].push(stop);
            }
        }

        this.dataStorageService.fetchPassengerSearchList(filter).pipe(takeUntil(this.unsubscribe$)).subscribe();
        this.searchService.setPassengerList([]);
        console.log(filter);
    }

    onSubmitChart() {
        const value = this.searchChartForm.value;
        const condition = {};
        const filters = {};
        const ranges = {};

        if (value.filters.status) {
            filters['status'] = value.filters.status;
        }
        if (value.filters.agency) {
            filters['agency'] = value.filters.agency;
        }
        if (value.filters.route_group_id) {
            filters['route_group_id'] = value.filters.route_group_id;
        }
        if (value.filters.stop) {
            filters['stop'] = value.filters.stop;
        }

        if (value.group_by) {
            condition['group_by'] = value.group_by;
        }
        if (value.group_by_extra) {
            condition['group_by_extra'] = value.group_by_extra;
        }

        if (value.ranges.created_from) {
            ranges['created_from'] = this.ngDateParserFormatter.format(value.ranges.created_from);
        }
        if (value.ranges.created_to) {
            ranges['created_to'] = this.ngDateParserFormatter.format(value.ranges.created_to);
        }
        if (value.ranges.on_board_from) {
            ranges['on_board_from'] = this.ngDateParserFormatter.format(value.ranges.on_board_from);
        }
        if (value.ranges.on_board_to) {
            ranges['on_board_to'] = this.ngDateParserFormatter.format(value.ranges.on_board_to);
        }

        if (!this.toolsService.isEmpty(filters)) {
            condition['filters'] = filters;
        }

        if (!this.toolsService.isEmpty(ranges)) {
            condition['ranges'] = ranges;
        }

        if (this.toolsService.isEmpty(condition)) {
            alert('Group By field required. ');
        } else {
            this.dataStorageService.fetchPassengerSearchChart(condition).pipe(takeUntil(this.unsubscribe$)).subscribe();
            this.searchService.setPassengerChart([]);
        }

    }

    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
}
